import queryString from "query-string";

import {
  BUSINESS_MERGE_EVENTS,
  UNMERGE_BUSINESSES,
} from "constants/actionTypes";
import { URLCreatorProps } from "actions/types";
import { serializeBusinessMergeEvents } from "lib/serializers/businessMergeEvents";
import { offlineActionCreator } from "./lib";

function urlCreator(props: URLCreatorProps = {}): string {
  const { id } = props;
  return queryString.stringifyUrl({
    url: "/v2/business-merge-event/",
    query: {
      target_business__cbid: id,
    },
  });
}

export const BusinessMergeEventsAction = offlineActionCreator(
  BUSINESS_MERGE_EVENTS,
  serializeBusinessMergeEvents,
  urlCreator,
  false,
);

export const BusinessUnMergeEventAction = offlineActionCreator(
  UNMERGE_BUSINESSES,
  serializeBusinessMergeEvents,
  props => `/v2/business-merge-event/${props.id}/undo/`,
  false,
);
